export default __webpack_public_path__ + "static/soc2-media-firm-trust-transformation-e6e81bea93ff311639952773775667bc.jpg";